import AddLogoModal from './AddLogoModal';
import { connectAddLogoModal, connectEditLogoModal } from './connect';
import EditLogoModal from './EditLogoModal';

const connectedAddLogoModal = connectAddLogoModal(AddLogoModal);
const connectedEditLogoModal = connectEditLogoModal(EditLogoModal);

export { connectedAddLogoModal as AddLogoModal };
export { connectedEditLogoModal as EditLogoModal };
